import { useState, useEffect } from "react";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-16 md:bottom-4 left-0 right-0 z-50 px-4 pointer-events-none">
      <div className="max-w-xl mx-auto bg-[#0F172A] text-white rounded-2xl shadow-2xl p-4 flex flex-col gap-3 pointer-events-auto border border-white/10">
        <div className="flex items-start justify-between gap-3">
          <p className="text-sm leading-relaxed text-white/80">
            Utilizziamo cookie tecnici e pubblicitari (Google AdSense) per migliorare la tua esperienza.
            Consulta la nostra{" "}
            <a href="/cookie-policy" className="underline text-white hover:text-white/70">Cookie Policy</a>.
          </p>
          <button onClick={reject} className="text-white/40 hover:text-white flex-shrink-0 mt-0.5">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-2">
          <button
            onClick={reject}
            className="flex-1 py-2 rounded-lg border border-white/20 text-xs font-semibold text-white/60 hover:bg-white/5 transition-colors"
            data-testid="cookie-reject"
          >
            Solo necessari
          </button>
          <button
            onClick={accept}
            className="flex-1 py-2 rounded-lg bg-white text-[#0F172A] text-xs font-bold hover:bg-white/90 transition-colors"
            data-testid="cookie-accept"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}
